import { ajaxRequest } from "../Ajax/ajax";
import { successToast } from "../utils";


export function removeInvitationsViaEmailFromInstance(email:string, instanceId, btn=false){

    const url = '/instance/' + instanceId.toString() + '/invitation/tutor/remove'

    const data = {
        email: email,
    }

    const success = function(data){
        successToast('Tutor/-in wurde von deiner Instanz entfernt', 'Erfolg', 6500, true);
    }

    return ajaxRequest(url, success, data, btn);

  }